function getNumberValueFromPx(valueInPx: string): number | undefined {
    if (!valueInPx.includes('px')) return;

    const numericValue = parseInt(valueInPx, 10);

    if (Number.isNaN(numericValue)) return;

    return numericValue;
}

export default getNumberValueFromPx;
